import {FormControl, MenuItem, Select, TableCell, TableRow} from "@material-ui/core";
import _ from "lodash";
import React from "react";
import {makeStyles} from "@material-ui/styles";
import moment from "moment";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  inheritFontWeight: {
    fontWeight: 'inherit',
  }
}));


const keys = [
  {id: 'currently_employed_company_crd_id', name: 'currently_employed_company_crd_id'},
  {id: 'currently_employed_company_branch_city', name: 'currently_employed_company_branch_city'},
  {id: 'currently_employed_company_branch_country', name: 'currently_employed_company_branch_country'},
  {id: 'currently_employed_company_branch_state', name: 'currently_employed_company_branch_state'},
  {id: 'currently_employed_company_branch_street_1', name: 'currently_employed_company_branch_street_1'},
  {id: 'currently_employed_company_branch_street_2', name: 'currently_employed_company_branch_street_2'},
  {id: 'currently_employed_company_branch_postal', name: 'currently_employed_company_branch_postal'},
  {id: 'currently_employed_company_branch_id', name: 'currently_employed_company_branch_id'},
]
const CompanyBranchesRow = (props) => {
  const {companyBranches, handleOnChangePrimaryLocation} = props;
  const classes = useStyles();

  const onBranchChange = (branch, value) => {
    handleOnChangePrimaryLocation(branch, value);
  }

  return (
    companyBranches.map(((branch, index) =>
        <TableRow hover key={`row-branch-${index}`}>
          {keys.map(((key) =>
              <TableCell key={`${key.name}-row-data-${index}`} className={classes.inheritFontWeight}>
                {_.isNil(branch[key.id]) ? '' : `${branch[key.id]}`}
              </TableCell>
          ))}
          <TableCell className={classes.inheritFontWeight}>
            {
              moment(branch.currently_employed_company_ela_begin_date, "YYYY-MM-DD").format('MM/DD/YYYY')
            }
          </TableCell>
          <TableCell className={classes.inheritFontWeight}>
            <FormControl required fullWidth>
              <Select
                  variant="outlined"
                  name='primary_location'
                  value={branch.currently_employed_company_primary_location ? 'Yes' : 'No'}
                  onChange={(e) => onBranchChange(branch, e.target.value)}
              >
                  <MenuItem key='yes' value='Yes'>Yes</MenuItem>
                  <MenuItem key='no' value='No'>No</MenuItem>
              </Select>
            </FormControl>
          </TableCell>
            <TableCell className={classes.inheritFontWeight}>
                {
                    branch.currently_employed_company_automatic ? 'Yes' : 'No'
                }
            </TableCell>
            <TableCell className={classes.inheritFontWeight}>
                {
                    branch.hq ? 'Yes' : 'No'
                }
            </TableCell>
        </TableRow>
    ))
  )
}

export default CompanyBranchesRow;